module.exports = __webpack_public_path__ + "media/fonts/Oricons-93b8f55d2d31416fbe0b94a99629d693.woff2";